import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Collapse
} from 'react-bootstrap';
import {
  pageTypes,
  scenarios as scenarioHelpers
} from './../helpers';
import JobParamsInfoContainer from './../Containers/JobParamsInfoContainer.jsx';
import JobMetricsInfoContainer from './../Containers/JobMetricsInfoContainer.jsx';
import AnnotationsJiraTicketContainer
  from './../Containers/AnnotationsJiraTicketContainer.jsx';
import InstallerTestInfoContainer
  from './../Containers/InstallerTestInfoContainer';
import JobHistoryContainer from './../Containers/JobHistoryContainer';
import InfoViewComponent from './InfoViewComponent';

const ScenarioListItemDetailsComponent = (
  {
    title,
    columnCount,
    jobId,
    scenario,
    expanded,
    areFailedTests,
    displayAllMetrics,
    pageType
  }) => {
  const colWidth = displayAllMetrics ? 12 : 6;
  return (
    <tr>
      <td colSpan={columnCount} style={{ padding: expanded ? undefined : 0 }}>
        <Collapse in={expanded}>
          <div>
            <Row>
              <Col md={colWidth}>
                {
                  areFailedTests ?
                    <AnnotationsJiraTicketContainer
                      scenarioName={scenario.name}
                    /> : null
                }
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <InfoViewComponent
                  title={'Scenario Details'}
                  items={{ reason: scenario.reason || scenarioHelpers.NO_REASON_FOUND }}
                  showWide
                />
              </Col>
            </Row>
            { pageType === pageTypes.INSTALLERTESTS ?
              <div>
                <Row>
                  <Col md={colWidth}>
                    <InstallerTestInfoContainer
                      jobId={jobId}
                      title={title}
                      scenarioStatus={scenario.status}
                      scenarioRunner={scenario.runner}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={colWidth}>
                    {
                      jobId ?
                        <JobParamsInfoContainer
                          title={title}
                          jobId={jobId}
                          displayAllMetrics={displayAllMetrics}
                        /> :
                        <p>Loading job parameters...</p>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {
                      jobId ?
                        <JobHistoryContainer
                          scenarioId={scenario.id}
                        /> :
                        <p>Loading jobs history...</p>
                    }
                  </Col>
                </Row>
              </div> :
              <div>
                <Row>
                  <Col md={12}>
                    {
                      jobId ?
                        <JobParamsInfoContainer
                          title={title}
                          jobId={jobId}
                          displayAllMetrics={displayAllMetrics}
                        /> :
                        <p>Loading job parameters...</p>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {/* Use Params here again instead of metrics becuase
                      the metrics are not ready for case amending job yet.
                      Need to add that to case amending project and
                      corresponding python script*/
                      jobId ?
                        <JobMetricsInfoContainer
                          title={title}
                          jobId={jobId}
                          displayAllMetrics={displayAllMetrics}
                          scenarioName={scenario.name}
                        /> :
                        <p>Loading job metrics...</p>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {
                      jobId ?
                        <JobHistoryContainer
                          scenarioId={scenario.id}
                        /> :
                        <p>Loading jobs history...</p>
                    }
                  </Col>
                </Row>
              </div>
            }
          </div>
        </Collapse>
      </td>
    </tr>
  );
};

ScenarioListItemDetailsComponent.propTypes = {
  title: PropTypes.string.isRequired,
  columnCount: PropTypes.number.isRequired,
  jobId: PropTypes.number,
  scenario: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    reason: PropTypes.string.isRequired,
    runner: PropTypes.string.isRequired
  }),
  jobIdNameNumberPairs: PropTypes.object,
  expanded: PropTypes.bool.isRequired,
  areFailedTests: PropTypes.bool.isRequired,
  displayAllMetrics: PropTypes.bool,
  pageType: PropTypes.object
};

export default ScenarioListItemDetailsComponent;


// WEBPACK FOOTER //
// src/Components/ScenarioListItemDetailsComponent.jsx